import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import "./FilterCoreModal.css";

const FilterCoreModal = ({ isOpen, toggle, children, title }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} className="custom-modal" scrollable>
      <ModalHeader className="border-0 py-0" toggle={toggle}>
        {title}
      </ModalHeader>
      <ModalBody className="m-0">{children}</ModalBody>
    </Modal>
  );
};

export default FilterCoreModal;
